import React from "react";
import {
  Privacy_Policy_title,
  Privacy_Policy_image,
  half_circle_bg_image,
  half_circle_bg_image2,
  book_logo3,
  Proschool_logo,
} from "../../assets/images/images";
import { NavLink, useNavigate } from "react-router";
import HomeNavbar from "../home/components/HomeNavbar";
import { useDispatch, useSelector } from 'react-redux';
import Footer from "../home/components/Footer";
import useBranding from "../../hooks/useBranding";

// Policy version metadata. COPPA requires fresh parental consent on material
// changes, which cannot be evidenced without a dated, versioned policy — so bump
// these whenever the text below changes materially.
const PRIVACY_POLICY_EFFECTIVE_DATE = "TO BE CONFIRMED BY LEGAL";
const PRIVACY_POLICY_LAST_UPDATED = "TO BE CONFIRMED BY LEGAL";
const PRIVACY_POLICY_VERSION = "1.0";

const PrivacyPolicyProschool = () => {
  const branding = useBranding();
  const appName = branding.productName;

  const navigate = useNavigate();
  const globalState = useSelector((state) => state.globalState);
  const subadmin_details = globalState.subadmin_details;
  const handleClick = (e) => {
    e.preventDefault(); // Prevent default link behavior

    // Navigate to the home page
    navigate("/");

    // Use setTimeout to delay the scroll to the specific section
    setTimeout(() => {
      const element = document.getElementById("revolution_sec_new");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // Adjust the timeout as needed
  };

  return (
    <>
      <HomeNavbar />
      <div className="Terms-and-Conditions-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="Terms-and-Conditions-wrapper">
                <div className="Privacy_Policy_title">
                  <img src={Privacy_Policy_title} />
                </div>
                <div className="Terms-and-Conditions-image">
                  <img src={Privacy_Policy_image} />
                </div>
                <div className="Terms-and-Cond itions-list-wrapper">
                  <div className="Terms-and-Conditions-list-foldre">
                    <p>
                      <strong>Effective Date:</strong> {PRIVACY_POLICY_EFFECTIVE_DATE} &nbsp;|&nbsp;{" "}
                      <strong>Last updated:</strong> {PRIVACY_POLICY_LAST_UPDATED} (v{PRIVACY_POLICY_VERSION})
                    </p>
                    <h2>I. Introduction</h2>
                    <p>
                      Welcome to {appName}, a brand operated by Arcot AI Solutions Private Limited, an innovative Learning Management System (LMS) platform. We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and protect the personal information of users on our platform. Our commitment to transparency means we strive to inform our users about how their data is handled. We encourage you to read this Privacy Policy carefully. By continuing to use our services, you acknowledge that you have read, understood, and agreed to this Privacy Policy.
                    </p>

                    <h6>Use of Large Language Models (LLMs):</h6>
                    <p>
                      {appName} uses Large Language Models (LLMs), including generative AI systems, to support certain educational, analytical, and functionalities within the platform. These LLMs operate under strict privacy and security controls and process user information solely for providing and improving {appName}’s services. LLM usage is governed by this Privacy Policy, applicable data protection laws, and contractual safeguards
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>II. CHILDREN’S AND STUDENTS’ DATA PROTECTION AND COMPLIANCE</h2>
                    <p>
                      {appName} is committed to safeguarding the privacy of child and student users and complies with all applicable child-protection, educational-records, and data-protection laws. Our compliance obligations under each statute are outlined separately below
                    </p>
                    
                    <ol>
                      <li>
                        <strong>Compliance with the Children’s Online Privacy Protection Act (COPPA)</strong>
                        <p>For users under the age of 13 in the United States, {appName}:</p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                obtains Verifiable Parental Consent before collecting, using, or disclosing personal information;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                collects only information that is reasonably necessary for participation in the educational services                            
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                provides parents and guardians with the right to review, correct, delete, or withdraw consent for the processing of their child’s personal information; and                            </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                restricts data use exclusively to educational and safety-related purposes
                              </p>
                            </span>
                          </li>
                        </ul>

                      </li>
                      <li>
                        <strong>Compliance with the Family Educational Rights and Privacy Act (FERPA)</strong>
                        <p>
                          When {appName} is used by educational institutions in the United States, we may be designated as a “school official” with legitimate educational interest. Accordingly, {appName}:
                        </p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                processes student education records solely under the direction and control of the educational institution;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                uses such data only for educational purposes and not for commercial use;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                grants access rights to parents, guardians, and eligible students consistent with FERPA; and                              
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                ensures that no disclosures of education records occur except as permitted under FERPA or authorized by the institution.
                              </p>
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Compliance with the Protection of Pupil Rights Amendment (PPRA)
                        </strong>
                        <p>For institutions subject to PPRA, {appName} ensures that:</p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                no personal information from students is collected for marketing or non-educational purposes; 
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                parents and educational institutions maintain rights regarding surveys, evaluations, and sensitive information collection; and
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                processing activities involving student data align strictly with institutional directives and PPRA safeguards.
                              </p>
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Compliance with the Children’s Internet Protection Act (CIPA)</strong>
                        <p>
                          In contexts where CIPA applies, {appName} supports educational institutions in meeting CIPA requirements by:                        </p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                incorporating content-filtering and online-safety measures intended to protect minors from harmful or inappropriate material;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                maintaining technical and organizational controls to ensure safe online learning environments; and
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                enabling institutions to exercise oversight over student interactions and content access.
                              </p>
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Compliance with the General Data Protection Regulation (GDPR)</strong>
                        <p>
                          For users located in the European Union or subject to GDPR protections, {appName}
                        </p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                processes personal data of children and students only on the basis of valid consent from a parent or guardian, or contractual necessity when directed by an educational institution acting as controller;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                restricts collection to the minimum data necessary for educational purposes;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                provides all GDPR rights, including access, rectification, erasure, restriction, and objection; and
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                implements robust technical and organizational measures to ensure lawful, fair, and transparent processing.
                              </p>
                            </span>
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>III. COMPLIANCE WITH INDIAN AND MAHARASHTRA EDUCATION AND DATA PROTECTION LAWS</h2>
                    <p>
                      {appName} separately complies with the following Indian statutory and regulatory frameworks:
                    </p>
                    
                    <ol>
                      <li>
                        <strong>Information Technology Act, 2000 (IT Act) and IT Rules, 2011</strong>
                        <p>
                          {appName} adheres to the Information Technology Act, 2000 and the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011 by:
                        </p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                implementing reasonable security practices and procedures;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                protecting Sensitive Personal Data or Information (SPDI);                            
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                obtaining consent before collection and processing;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                ensuring lawful disclosure and data-minimization; and
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                applying appropriate safeguards for children’s information.
                              </p>
                            </span>
                          </li>
                        </ul>

                      </li>
                      <li>
                        <strong>Digital Personal Data Protection Act, 2023 (DPDP Act)</strong>
                        <p>
                          As the DPDP Act comes into force, {appName} is aligning its processing activities to ensure compliance, including:
                        </p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                obtaining valid consent from data principals;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                providing notice of processing purposes;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                ensuring rights such as access, correction, and erasure;                            
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                adopting data-minimization and purpose-limitation principles; and
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                implementing security safeguards required under the Act.
                              </p>
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>
                          Right of Children to Free and Compulsory Education Act, 2009 (RTE Act)
                        </strong>
                        <p>In educational settings in India, {appName} supports compliance with the RTE Act by:</p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                ensuring responsible handling of children’s educational information; 
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                respecting institutional obligations relating to access, equality, and safety; and
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                supporting schools in meeting reporting, record-keeping, and child-safety obligations.
                              </p>
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Maharashtra Right of Children to Free and Compulsory Education Rules, 2011 (as amended)</strong>
                        <p>
                          For institutions governed by Maharashtra’s RTE Rules, {appName}:
                        </p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                aligns its data-processing practices with state-specific educational and safety requirements
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                supports institutional compliance with reporting and record-management obligations; and
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                ensures secure processing of children’s data in accordance with state directives
                              </p>
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong> Maharashtra State Board of Secondary and Higher Secondary Education Regulations</strong>
                        <p>
                          When {appName} is used by institutions under the State Board, the platform:
                        </p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                adheres to Board-mandated data-handling standards;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                supports secure management of student academic records; and
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                complies with directives issued by the Board and the School Education and Sports Department
                              </p>
                            </span>
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>IV. INFORMATION WE COLLECT</h2>
                    <ol>
                      <li>
                        <strong>Information You Provide:</strong>
                        <p>
                          When you use our services, you may provide us with personal information such as your name, contact information, educational background, and other relevant data. This may include, but is not limited to, academic qualifications, enrollment details, feedback, coursework submissions, and communications with instructors. We access files and associated metadata (such as file names, creation dates, and folder structures) stored in your Google Drive to enable file management, sharing, and submission functionalities within the {appName} platform. We may process the information you provide through interactions with AI-powered features, including LLM-based tools used for learning assistance, content generation, summarization, feedback, and support. These interactions may contain personal information, and such data is processed in accordance with this Privacy Policy. The content you submit to these features is sent to third-party large language model providers — currently OpenAI and Anthropic — which process it solely to return the response and act on our instructions. Under the commercial API terms applicable to this use, neither provider uses that content to train its models, and each retains the submitted content for no longer than 30 days, for abuse and misuse monitoring only, before deleting it.
                        </p>
                      </li>
                      <li>
                        <strong>Information We Collect Automatically:
                        </strong>
                        <p>
                          We may automatically collect certain information about your use of our services, including your IP address, device information, browser type, access times, and usage patterns . This helps us to understand how you interact with our platform and improve your user experience
                        </p>
                      </li>
                      <li>
                        <strong>Cookies and Similar Technologies:</strong>
                        <p>
                          We may use cookies and similar technologies to collect information about your interactions with our services and enhance your user experience. These technologies may store data for varying periods depending on their purpose, such as remembering your login preferences or tracking your progress within the platform. Where necessary, we may use technical tools to optimize performance of LLM-powered features, such as maintaining session stability and improving relevance of responses. We also use Google Tag Manager and the measurement tags configured through it to understand how visitors use our public website. Cookies are not used for targeted advertising directed at children.
                        </p>
                        <p>
                          <strong>Service Providers We Rely On:</strong> we use the following third-party providers, each of which processes personal information only as needed to provide its service to us: <strong>Amazon Web Services</strong> (cloud hosting and storage of uploaded files); <strong>Google</strong> — Firebase sign-in, which stores the email address used to identify your account; Google Drive, where importing a file opens Google’s own picker so that you select the files yourself, and we receive only the files you select plus the file and folder names needed to display that picker; and Google Tag Manager as described above; <strong>OpenAI</strong> and <strong>Anthropic</strong> (the large language models behind our AI features, each retaining submitted content for no longer than 30 days, for abuse monitoring only, before deleting it); <strong>Razorpay</strong> and <strong>Cashfree</strong> (payment processing, where you purchase a course); and <strong>Zoho Desk</strong> (support ticketing, where you contact us for help). We do not control, and are not responsible for, the privacy practices of these or any other third party.
                        </p>
                      </li>
                      <li>
                        <strong>Data Collection: </strong>
                        <p>
                          We collect only the personal information reasonably necessary for a child to participate in the service, and we do not condition a child’s participation on providing information that is not reasonably necessary.
                        </p>
                      </li>
                    </ol>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>
                    V.  HOW WE USE YOUR INFORMATION
                    </h2>
                    <ol>
                      <li>
                        <strong>Personalized Learning Experience:
                        </strong>
                        <p>
                          We use the information we collect to provide, maintain, and improve our services, including offering personalized learning paths and resources tailored to your needs. Our AI algorithms analyze your educational history, preferences, and performance data to suggest relevant courses, learning materials, and study tips.                        </p>
                      </li>
                      <li>
                        <strong>Communication:
                        </strong>
                        <p>
                          We may use your information to communicate with you about our services, including updates, educational resources, and administrative messages. Notifications about new courses or features are sent periodically, while important administrative messages are delivered as necessary.                        </p>
                      </li>
                      <li>
                        <strong>File Upload and Storage:</strong>
                        <p>
                          We may use your information for research and analytics purposes to understand trends in educational data, evaluate learning outcomes, and enhance our AI algorithms. This helps us to continuously improve our platform and offer a better learning experience. Teachers can share files with students by setting specific permissions (e.g., view-only, edit), ensuring controlled access to educational content. Students can select files from their Google Drive to submit as assignments, making the process more accessible. Teachers can organize files within Google Drive into folders for different courses or assignments, aiding in the efficient management of educational resources.                        </p>
                      </li>
                      <li>
                        <strong>Research and Analytics:</strong>
                        <p>
                          We may use your information for research and analytics purposes to understand trends in educational data, evaluate learning outcomes, and enhance our AI algorithms. This helps us to continuously improve our platform and offer a better learning experience.                        </p>
                      </li>
                      <li>
                        <strong>AI and LLM-Based Processing:</strong>
                        <p>
                          {appName} uses Large Language Models (LLMs) to enhance the learning experience by enabling features such as personalized explanations, content recommendations, automated feedback, tutoring assistance, and natural-language support interactions. LLMs may process user-generated text (including questions, prompts, and submissions) solely for the following purposes:
                        </p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                generating educational content, insights, or explanations;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                improving accuracy and relevance of platform responses
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                supporting administrative workflows for teachers and students; and
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                ensuring safety, quality, and compliance with platform policies.
                              </p>
                            </span>
                          </li>
                        </ul>
                      </li>
                    </ol>
                    <p>We do not use LLMs to build user profiles for marketing or behavioral advertising, nor do we permit LLMs to independently store or reuse personal information outside our controlled environment.</p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>VI. HOW WE SHARE YOUR INFORMATION</h2>
                    <p>
                      {appName} limits the sharing of personal information to only those entities necessary for the operation, security, and enhancement of the platform. We do not engage general third-party service providers and do not disclose user data for advertising, marketing, or non-educational purposes. Data is shared strictly under controlled and legally compliant circumstances, as outlined below.
                    </p>
                    
                    <ol>
                      <li>
                        <strong>Use of Google Services (including Google Drive)</strong>
                        <p>
                          {appName} relies on Google services to provide core platform functionalities such as secure data storage, document management, and resource sharing. Accordingly:
                        </p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                Your information may be stored and processed on Google's servers when you use features such as uploading assignments, saving documents, or accessing educational materials.
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                All processing performed by Google on our behalf is conducted under confidentiality, security, and restricted-use obligations consistent with applicable privacy laws.
                              </p>
                            </span>
                          </li>
                        </ul> <br/>
                        <p><strong>External Processing:</strong></p>
                        <p>
                          Google may process your information on {appName}'s behalf to support data storage, file management, system operations, and security infrastructure, in accordance with Google's privacy policy and contractual safeguards.
                        </p> <br/>
                        <p><strong>Legal Requirements:</strong></p>
                        <p>
                          Google may disclose your information if legally required, including to comply with court orders, enforce its terms of service, or address security concerns.
                        </p> <br/>
                        <p>
                          By using {appName}, you acknowledge that your data may be processed and stored by Google in accordance with Google's privacy practices.
                        </p>
                      </li>
                      <li>
                        <strong>AI and Large Language Model (LLM) Processors</strong>
                        <p>
                          Where {appName} uses Large Language Models or AI-powered features, such processing occurs either:
                        </p>
                        <ol>
                          <li>within {appName}'s secure environment, or</li>
                          <li>through vetted AI technology providers acting strictly as processors under binding contractual terms.</li>
                        </ol>
                        <p>Such processors:</p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>
                                must maintain confidentiality and comply with COPPA, FERPA, GDPR, PPRA, CIPA, the DPDP Act, and other applicable laws;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                are prohibited from using personal information for their own purposes;
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                have no rights to train their models using {appName} data unless explicitly permitted and legally compliant; and
                              </p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>
                                may only process information necessary to support educational features and platform functionality.
                              </p>
                            </span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Educational Institutions and Partners</strong>
                        <p>
                          Where {appName} is used by or in collaboration with educational institutions or partners, we may share relevant personal information with them solely for:
                        </p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>facilitating instructional activities;</p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>delivering educational content;</p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>managing academic records and assessments; or</p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>supporting authorized administrative functions.</p>
                            </span>
                          </li>
                        </ul>
                        <p>
                          All institutions and partners receiving such information must use it only for agreed educational purposes and must apply privacy and security measures consistent with applicable laws and institutional policies.
                        </p>
                        <p>
                          {appName} strictly follows the academic standards, syllabus requirements, and instructional guidelines prescribed by the relevant school board(s) whether state, national, or international identified by the educational institution. All educational content generated or delivered through our platform, including curricula, courses, lesson plans, and assignments, is developed to remain fully aligned with the applicable school board framework. Our AI systems are configured, trained, and optimized based on the curriculum structures and learning objectives established by these school boards. This ensures that AI-generated educational outputs remain compliant with board-mandated standards and appropriate for the intended grade level or academic programme.
                        </p>
                      </li>
                      <li>
                        <strong>Compliance with Legal Obligations</strong>
                        <p>
                          {appName} may disclose personal information where required to do so by applicable law, legal process, or governmental authority, or where such disclosure is necessary to:
                        </p>
                        <ul className="privacy-policy-list-for-external-Processing">
                          <li>
                            <span>
                              <p>protect our rights, property, or safety;</p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>comply with judicial or regulatory requirements; or</p>
                            </span>
                          </li>
                          <li>
                            <span>
                              <p>safeguard the rights, property, or safety of users or others.</p>
                            </span>
                          </li>
                        </ul>
                        <p>
                          All disclosures are limited to what is legally required and are carried out with appropriate safeguards.
                        </p>
                      </li>
                    </ol>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>VII. PURPOSE OF DATA COLLECTION</h2>
                    <p>
                      At {appName}, we collect data to provide a seamless, personalized, and enhanced educational experience for our users. LLM-powered analysis may be used to personalize educational content, identify learning patterns, and generate recommendations. All LLM outputs are limited to educational and service-delivery purposes and are not used for marketing, profiling unrelated to education, or automated decision-making that produces legal or significant effects.
                    </p>
                    <p>Mentioned below is a detailed look at how we utilize the data collected:</p>
                    
                    <ol>
                      <li>
                        <strong>Personalized Learning Paths:</strong>
                        <p>
                          We use data such as your educational background, course selections, and interaction history to tailor learning paths that suit your unique needs and goals. Our AI algorithms analyze this information to suggest courses, study materials, and learning strategies that optimize your educational journey.
                        </p>
                      </li>
                      <li>
                        <strong>Platform Enhancement:</strong>
                        <p>
                          Data collected from user interactions helps us improve our Learning Management System by identifying areas for enhancement and ensuring that our platform remains user-friendly, efficient, and relevant to your educational needs.
                        </p>
                      </li>
                      <li>
                        <strong>Communication and Support:</strong>
                        <p>
                          We use your contact information to provide timely updates about new features, course offerings, and important notifications. This ensures you stay informed and receive support when needed, enhancing your overall experience on our platform.
                        </p>
                      </li>
                      <li>
                        <strong>User Experience Optimization:</strong>
                        <p>
                          We gather data on how users navigate and interact with the platform to enhance user experience. This includes optimizing site performance, simplifying navigation, and providing a more intuitive interface.
                        </p>
                      </li>
                    </ol>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>VIII. PARENTS RIGHTS, VERIFIABLE PARENTAL CONSENT, AND DIRECT NOTICE</h2>
                    <p>
                      {appName} respects the rights of parents, legal guardians, and, where applicable, educational institutions and eligible students under COPPA, FERPA, PPRA, CIPA, and the GDPR. Parents, legal guardians, and, where applicable, educational institutions or eligible students (under FERPA and GDPR) may at any time: (a) review the child's or student's personal information and education records that we process; (b) request correction or update of inaccurate or incomplete information; (c) request deletion of the child's or student's personal information; (d) restrict or object to certain processing activities, including non-essential profiling; and (e) refuse or withdraw consent to any further collection, use, or disclosure of the child's or student's personal information. Parents, guardians, and eligible students may request information about how their data is processed by LLMs and may object to or restrict the use of LLM-based features for their child except where such processing is essential to core educational services. To exercise these rights, you may contact us using the contact information provided in this Privacy Policy. We will verify the requester's identity (and, where applicable, authority to act on behalf of the child, student, or educational institution) and respond without undue delay and in any event within 14 days, subject to any longer period permitted or required by applicable law.
                    </p>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>IX. DATA SECURITY</h2>
                    <p>
                      {appName} prioritizes the protection of your personal information with rigorous security measures. We use encryption to secure data in transit and at rest, ensuring your information remains confidential. Access to data is restricted to authorized personnel who adhere to strict protocols. Regular security audits and assessments help us identify and address potential vulnerabilities. In the event of a security incident, we have a response plan to resolve issues promptly and notify affected users if necessary. We encourage you to use strong passwords and keep your login information private. We implement strict access controls, data-minimization techniques, and isolation safeguards to ensure that information processed by LLMs remains confidential and is not used for model training unless explicitly permitted and legally compliant.
                    </p>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>X. CATEGORIES OF INFORMATION COLLECTED</h2>
                    <ol>
                      <li>
                        <span>
                            <strong>Information Provided Directly:</strong> 
                          <p>
                            Personal information necessary for establishing and managing a student or child's account, such as name, contact information, education-related details, and other information provided by parents, guardians, or educational institutions.
                          </p>
                        </span>
                      </li>
                      <li>
                        <span>
                            <strong>Information Collected Automatically:</strong>
                          <p>
                            Usage data, device identifiers, browser details, geolocation information, interaction logs, and education-related behavioral data such as academic performance, learning preferences, and activity history.
                          </p>
                        </span>
                      </li>
                      <li>
                        <span>
                            <strong>Education Records and Student Data:</strong>
                          <p>
                            To the extent that any collected information constitutes an "education record" under FERPA or a "personal data" or "special category data" under GDPR, {appName} processes such data strictly under the instructions and authorization provided by the educational institution or the data subject's guardian.
                          </p>
                        </span>
                      </li>
                    </ol>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>XI. PURPOSE AND LEGAL BASIS OF PROCESSING</h2>
                    <p>
                      {appName} processes children's and student data strictly for educational and service-delivery purposes, including customizing learning experiences, generating assessments, facilitating content filtering and safety measures required under CIPA, improving platform performance, and conducting AI-based analysis to enhance educational outcomes. Under GDPR, processing is based on (i) consent obtained from the parent or guardian, or (ii) contractual necessity when processing is carried out under the direction of an educational institution acting as data controller.
                    </p>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>XII. DISCLOSURE OF INFORMATION COLLECTED</h2>
                    <p>
                      {appName} does not disclose children's or student users' personal information to third parties. We do not sell, monetize, or use children's or student data for behavioral advertising or non-educational profiling. Any disclosures required by law, court order, or governmental authority will be limited and carried out in compliance with applicable legal safeguards.
                    </p>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>XIII. PARENTAL, GUARDIAN, AND INSTITUTIONAL RIGHTS</h2>
                    <p>
                      Parents, guardians, and educational institutions retain all rights provided under COPPA, FERPA, PPRA, and GDPR, including the right to access the child's or student's personal information, request correction, restrict certain processing, review education-related records, and withdraw consent. Upon withdrawal of consent, {appName} will cease processing except as necessary to comply with legal obligations.
                    </p>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>XIV. DATA DELETION</h2>
                    <p>
                      Personal information of children and students is retained only for as long as necessary to provide the services or as required by applicable law. Upon a verified request from a parent, guardian, or educational institution, {appName} will delete the child's or student's personal information from its active systems within 20–30 days, unless retention is legally required, in which case such data will be isolated, access-restricted, and used solely for compliance purposes. {appName} implements technical and organizational measures, including content-filtering and safety mechanisms in line with CIPA, to protect minors from exposure to harmful online materials and to maintain the security, integrity, and confidentiality of all processed data.
                    </p>
                    <p>
                      LLM usage involving children's or students' data is limited to real-time processing for educational purposes. We do not allow children's personal information to be used for training generalized AI models, for aggregation into non-educational datasets, or for any form of behavioral profiling. Any LLM-related processing is performed under the direct control of the educational institution or with verified parental consent, as applicable.
                    </p>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>XV. DATA SHARING</h2>
                    <p>
                      All content provided on {appName}, including courses, lessons, assessments, and any other educational materials, is the intellectual property of the respective creators and {appName}. Users are strictly prohibited from reproducing, distributing, modifying, or using this content for any purpose outside the platform without explicit written permission from the content creators or {appName}. Any unauthorized use of the content may result in termination of access to our services and could lead to legal action.
                    </p>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>XVI. AI CHATBOT INTERACTIONS</h2>
                    <p>
                      {appName} uses AI chatbots powered by Large Language Models (LLMs) to provide personalized academic assistance, answer questions, facilitate communication, and support teachers and students. Interactions with AI chatbots may be analyzed to improve accuracy, quality, and relevance of educational responses.
                    </p><br/>
                    <p>
                      LLM-based interactions are processed in compliance with strict confidentiality, data-minimization, and security protocols. The information collected through chatbot interactions:
                    </p>
                    <ol>
                      <li>
                        <span>
                          <p>is used solely to enhance learning and platform functionality;</p>
                        </span>
                      </li>
                      <li>
                        <span>
                          <p>is not used for advertising or non-educational profiling;</p>
                        </span>
                      </li>
                      <li>
                        <span>
                          <p>is not used to train external or third-party LLMs unless lawfully permitted under written agreements; and</p>
                        </span>
                      </li>
                      <li>
                        <span>
                          <p>remains subject to all rights provided under COPPA, FERPA, GDPR, PPRA, CIPA, and Indian data protection laws.</p>
                        </span>
                      </li>
                    </ol>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>XVII. DATA RETENTION</h2>
                    <p>
                      We retain user data for as long as the user's account is active. If a user wishes to delete their account and associated data, they can request deletion by contacting us. Upon receiving a deletion request, we will promptly remove the user's data, subject to any legal obligations to retain certain information. We are committed to ensuring that your data is only kept for as long as necessary to provide our services effectively. Data processed by LLMs follows the same retention schedules as other user information. LLM-generated explanations, responses, or recommendations are transient unless intentionally saved by the user or required for educational records.
                    </p>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>XVIII. CHANGES TO PRIVACY POLICY</h2>
                    <p>
                      {appName} may update or modify this Privacy Policy at any time to reflect changes in our practices or to comply with legal requirements. The updated policy will be effective immediately upon posting on our website. We encourage you to periodically review this Privacy Policy to stay informed about how we protect your information. Your continued use of our services after any changes to the Privacy Policy will constitute your acknowledgment and acceptance of those changes. If {appName} materially expands its use of LLMs or introduces new AI-based processing capabilities involving personal information, we will provide notice and, where applicable, obtain parental, institutional, or user consent before applying such changes. If you do not agree with the updated policy, you should discontinue using our services. If we make material changes to children's data practices, we will provide direct notice and obtain new parental consent before applying changes to a child's data.
                    </p>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>XIX. FORCE MAJEURE</h2>
                    <p>
                      {appName} shall not be liable for any failure or delay in the performance of its obligations under this Privacy Policy to the extent such failure or delay is caused by events or circumstances beyond its reasonable control, including but not limited to: acts of God, natural disasters, epidemics or pandemics, war, terrorism, civil unrest, strikes or other labour disputes, embargoes, government orders or restrictions, power failures, failures of telecommunications or internet service providers, failures or material service interruptions of hosting, cloud, or infrastructure providers (including Google or AI infrastructure providers), or changes in applicable laws, regulations, or governmental policies ("Force Majeure Event").
                    </p>
                    <p>During a Force Majeure Event, {appName} will take commercially reasonable steps to:</p>
                    <ol>
                      <li>mitigate the impact of the Force Majeure Event on the security and confidentiality of personal information; and</li>
                      <li>restore the availability and normal operation of its services as soon as reasonably practicable.</li>
                    </ol>
                  </div>

                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>XX. CONTACT INFORMATION</h2>
                    <p>
                      For any queries or a detailed walk through of our platform, please contact us at {branding.infoEmail}. We are here to assist you with any questions or concerns you may have about our services or this Privacy Policy.
                    </p>
                  </div>
                </div>
                <div className="half-circle-bg-image">
                  <img src={half_circle_bg_image} />
                </div>
                <div className="half-circle-bg-image2">
                  <img src={half_circle_bg_image2} />
                </div>
                <div className="book-logo3">
                  <img src={book_logo3} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
      {/* <div className="footer-section" id="footer-section">
        <div className="footer-wraper">
          <div className="footer-link-folder">
            <p>Saddle River Day School 2</p>
          </div>
          <div className="footer-Quick-Links-folder">
            <h2>Quick Links</h2>
            <ul className="footer-Quick-Links">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/about">About Us</NavLink>
              </li>
              <li>
                <NavLink to="/privacy-policy">Privacy Policy</NavLink>
              </li>
            </ul>
          </div>
          <div className="footer-Quick-Links-folder">
            <h2>Contact</h2>
            <div className="footer-contact">
              <div className="footer-contact-folder">

                <a><i class="fa-solid fa-phone"></i></a>
                <span><a href="tel:+1 201-327-4050">+1 201-327-4050</a></span>
              </div>
              <div className="footer-contact-folder">
                <a><i class="fa-solid fa-envelope"></i></a>
                <a href="mailto: noreply@saddleriverday.org">kmerges@saddleriverday.org</a>
              </div>
              <div className="footer-contact-folder">
                <a><i class="fa-solid fa-location-dot"></i></a>
                <a href="https://www.google.com/maps/place/Saddle+River+Day+School/@41.0307394,-74.0880125,17z/data=!3m1!4b1!4m6!3m5!1s0x89c2e436c9e7ef3b:0xf060c34a65b01898!8m2!3d41.0307394!4d-74.0854376!16zL20vMGRkYzZ5?entry=ttu" target="_blank">Saddle River Day School, 147 Chestnut Ridge Road, Saddle River, NJ 07458​​.</a>
              </div>
            </div>
          </div>
          <div className='footer-get-in-touch-folder'>
            <span>Get in touch</span>
            <div className='footer-social-link-folder'>
              <a href='https://www.facebook.com/saddleriverdayschool' target="_blank"><i className="fa-brands fa-facebook"></i></a>
              <a href='https://twitter.com/srDSrebels' target="_blank"><i class="fa-brands fa-x-twitter"></i></a>
              <a href='https://www.instagram.com/saddleriverday/' target="_blank"><i className="fa-brands fa-instagram"></i></a>
              <a href='https://vimeo.com/srds' target="_blank"><i class="fa-brands fa-vimeo-v"></i></a>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default PrivacyPolicyProschool;
